import { useState } from "react"
import AuthCode from 'react-auth-code-input'
import styles from './PinCode.module.scss'
import eye from 'assets/icons/eye.png'
import hidden from 'assets/icons/hidden.png'
const PinCode = ({ setPinCode, passwordVisible }) => {

  const [showPassword, setShowPassword] = useState(false);
  // const handleOnChange = (res) => {
  //   setPinCode(res)
  // }
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [isError, setIsError] = useState(false);
  const handleOnChange = (value) => {
    setIsError(value.length < 4);
    if (value.length == 4){
    setPinCode(value)
  }
    
  };
  return (
    <>
     <div src={eye} type="button" className={styles.show__password} onClick={togglePasswordVisibility}>
    {showPassword ? <> <img src={hidden}></img> </> : <> <img src={eye}></img> </>}
  </div>
    {/* <AuthCode
      length={4}
      onChange={handleOnChange}
      allowedCharacters={'numeric'}
      isPassword={showPassword ? passwordVisible : 'True'}
      containerClassName={styles.container}
      inputClassName={styles.inputs}
    /> */}
    <AuthCode
      length={4}
      onChange={handleOnChange}
      allowedCharacters={'numeric'}
      isPassword={showPassword ? passwordVisible : 'True'}
      containerClassName={styles.container}
      required
      inputClassName={isError ? `${styles.inputs} ${styles.error}` : styles.inputs}
      autoComplete="off new-password"
      autocomplete="off new-password"
    />
  
  </>
  )
}
export default PinCode
